const imageCards = ()=>({
    selectedIndex: 1,
    init(){

    },
  changeTab(index){
    this.selectedIndex = index
  }
  })

export default imageCards

window.addEventListener("alpine:init", ()=>{
  Alpine.data("image_cards", imageCards)
})